import React, { useContext, useEffect, useState } from "react";
import { JSDCContext, JSDCProvider } from "jsdc-dui/dist/JSDC/Context";
import JSDC from "jsdc-dui/dist/JSDC";
import { latLng, latLngBounds } from "leaflet";
import {
  IDuiContextProviderProps,
  DuiContextProvider,
} from "jsdc-dui/dist/components/Context";
import DguideWalksApp from "jsdc-dui/dist/components/DguideWalksApp";
import { DguidewalksProvider } from "jsdc-dui/dist/JSDC/Dguidewalks/Context";
import "jsdc-dui/dist/style/index.css";
import "./index.scss";
import ConfigProvider from "jsdc-dui/dist/JSDC/Dguidewalks/ConfigProvider";
import headerImg from "./assets/key-art_Desktop.png";
import headerImgMb from "./assets/key-art_mobile.jpg";
import aboutImg from "./assets/about.png";

import "./i18n";

//TODO: EVENT_ID
const EVENT_ID = "n0021";

//TODO: aboutWalkContent
const aboutWalkContent = `走讀地圖使用說明
1.這是以現今行政區為貢寮區美豐里雞母嶺村落，過往生活故事為主軸的數位走讀地圖，以蕭學苑（人稱老蕭，1962年出生，成長在雞母嶺）記憶中的生活經驗為主題，不代表雞母嶺人家都有同樣的經歷。共收錄26個故事，以文字為主、照片為輔。文史資料若有出入，請不吝指教。
2.地圖中標記出與26個與生活故事關聯的地點，標記的地點是符合故事情境或故事發生的相符位置，實際上同樣的故事可能會出現在多處地點。
3.地標型建築物，例如福安廟、豐珠中學等，則標記在地圖精確位置上。
`;

const credit = `
<div>
    本圖臺是由遇見雞母嶺及智紳數位文化有限公司共同協力建置：
    <br>1. 圖臺內容：雞母嶺的生活故事
    <br>2. 圖臺系統開發：智紳數位文化事業有限公司
    <br>3. 建置經費來源：國立臺灣海洋大學貢寮美境山海川區域發展深耕USR計畫、遇見雞母嶺
    <br>
    <br>本圖臺內容其內容著作財產權由遇見雞母嶺所有，若有其他使用或授權需求，請洽下列單位。
    <br>聯絡方式：遇見雞母嶺蕭先生yuanwake@gmail.com洽詢。
</div>
`;

const duiConfigProps: IDuiContextProviderProps = {
  sidebarTitle: "",
  sidebarSubtitle: "",
  aboutWalkImgSrc: aboutImg,
  aboutWalkContent,
  credit,
  creditHref: "https://www.facebook.com/JRSHENDigitalCulture/",
  headerMBImgSrc: headerImgMb,
  headerDImgSrc: headerImg,
  weatherConfig: {
    token: "CWB-232A270E-12F1-4381-B9F2-DF2D2670A077",
    locations: [{ county: "新北市", town: "貢寮區" }], //TODO: weather 氣象預測地點
  },
  themeConfig: {
    "--dui-primary": "#224A97", //TODO: theme
    "--dui-accent": "#B4712A", //TODO: 數位集章按鈕顏色
    "--dui-secondary": "#224A97", //TODO: theme
    "--dui-bg-secondary": "#ffc361", // Dialog background
    "--dui-bg-accent": "#91AF6D", //TODO: background
  },
  settingConfig: {
    disabled: true, // 左側選單不出現「工具設定」
    // languageSwitcherDisabled: true, // 或：保留「工具設定」，只藏語言切換器
  },
};
// #e4e7cb
// 景點的 icon、點擊開集章卡片、cluster、集章 key、`?id=` 深連結、
// 列表的定位與導航、底圖、線、路線顏色選單都由 jsdc-dui 依 Strapi 的資料建立，這裡不需要再處理圖層。
function App() {
  const { Jsdc } = useContext(JSDCContext);

  useEffect(() => {
    (window as any).JSDC = Jsdc;
  }, [Jsdc]);

  return (
    <div className="root">
      <DguideWalksApp
        language="zh-TW"
      />
    </div>
  );
}

const config = new ConfigProvider({ eventId: EVENT_ID });

const AppWrapper: React.FC = () => {
  const [Jsdc] = useState(
    new JSDC(EVENT_ID, {
      bound: latLngBounds(
        //TODO: map view bound
        latLng(25.06778070884489, 121.89181841641984),
        latLng(25.067209050034123, 121.90218977667851),
      ),
      maxZoom: 20,
    }),
  );

  return (
    <JSDCProvider Jsdc={Jsdc}>
      <DguidewalksProvider
        Jsdc={Jsdc}
        config={config}
      >
        <DuiContextProvider
          {...duiConfigProps}
          pathColorConfig={{ enabled: true }}
        >
          <App />
        </DuiContextProvider>
      </DguidewalksProvider>
    </JSDCProvider>
  );
};

export default AppWrapper;
